import React from 'react';
import {Link} from 'react-router-dom';

import styles from './styles.module.scss';
import {Logo, LogoPrimary} from '../../assets';
import {routes} from '../../constants/routes';

export const LogoComponent = ({primary}) => {
  return (
    <Link to={routes.home}>
      {primary ? (
        <div className={styles.logoPrimaryWrapper}>
          <LogoPrimary />
        </div>
      ) : (
        <div className={styles.logoWrapper}>
          <Logo />
        </div>
      )}
    </Link>
  );
};
